// src/routes/UserRoutes.js
import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// Pages
import HomePage from "../components/User/Home/HomePage";
import TermsOfService from "../components/User/TermsOfService";
import PrivacyPolicy from "../components/User/PrivacyPolicy";

/*
  🧭 ScrollToTopOnRoute
  - Resets scroll position on route changes (unless an in-page hash is present)
*/
function ScrollToTopOnRoute() {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) return;
        window.scrollTo({ top: 0, behavior: "auto" });
    }, [location.pathname, location.hash]);

    return null;
}

export default function UserRoutes() {
    return (
        <>
            <ScrollToTopOnRoute />

            <Routes>
                {/* 3 Core Static Pages */}
                <Route path="/" element={<HomePage />} />
                <Route path="/terms-and-conditions" element={<TermsOfService />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />

                {/* Fallback to Home */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </>
    );
}
